import Marquee from "react-fast-marquee";

const words = ["Solid Wood", "Handcrafted", "Timeless", "Made in Kashmir", "Heirloom Quality"];

export default function EditorialMarquee() {
  return (
    <section data-testid="editorial-marquee" className="py-16 border-y border-border overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-6xl md:text-8xl text-stroke px-8">{w}</span>
            <span className="text-primary text-4xl md:text-6xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
